import type { QueryClient } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";

import type { Service } from "../service";

import { GET_PAGINATED, QUERY_KEYS } from "./common";

import { throwify } from "~/shared/fp";
import type { GetQueryOptions, InferQueryGenerics } from "~/shared/tanstack-query";

type UseGetPaginatedGenerics = InferQueryGenerics<
  Service[typeof GET_PAGINATED],
  ReturnType<(typeof QUERY_KEYS)[typeof GET_PAGINATED]>["queryKey"]
>;
type UseGetPaginatedOptions = GetQueryOptions<UseGetPaginatedGenerics>;

function useGetPaginated(
  service: Service,
  params: Parameters<Service[typeof GET_PAGINATED]>[0],
  options?: Omit<UseGetPaginatedOptions, "queryKey" | "queryFn">,
  queryClient?: QueryClient,
) {
  return useQuery(
    {
      ...options,
      ...QUERY_KEYS[GET_PAGINATED](params),
      queryFn: async () => throwify(await service[GET_PAGINATED](params)()),
    } as UseGetPaginatedOptions,
    queryClient,
  );
}

export { useGetPaginated };
